// Drag handle on the project-tree rail's right edge. Keeps the `.ws-tree-resize`
// class (which overhangs the aside by 3px) rather than the generic
// `.ws-rail-resize`; the mechanics are shared via `ui/RailResizer`.

import { useTranslation } from 'react-i18next';
import { RailResizer } from '../ui/RailResizer';
import { treeRail } from './useTreeRailWidth';

export function TreeRailResizer() {
  const { t } = useTranslation('projects');
  return <RailResizer rail={treeRail} label={t('tree.railResizer.label')} className="ws-tree-resize" />;
}
